MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};

MinimogTheme.config = {
  isRTL: document.documentElement.getAttribute("dir") === "rtl",
  mqlMobile: false,
  mqlTablet: false,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px)",
  swiperModules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination],
};

MinimogTheme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

MinimogTheme.delayToUserInteraction = (function () {
  class ScriptLoader {
    constructor(callback, delay = 5000) {
      this.loadScriptTimer = setTimeout(callback, delay);
      this.userInteractionEvents = [
        "mouseover",
        "mousemove",
        "keydown",
        "touchstart",
        "touchend",
        "touchmove",
        "wheel",
      ];

      this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
      this.userInteractionEvents.forEach((event) => {
        window.addEventListener(event, this.onScriptLoader, {
          passive: !0,
        });
      });
    }

    triggerScriptLoader(callback) {
      callback();
      clearTimeout(this.loadScriptTimer);
      this.userInteractionEvents.forEach((event) => {
        window.removeEventListener(event, this.onScriptLoader, {
          passive: !0,
        });
      });
    }
  }

  return ScriptLoader;
})();

// Improve initial load time by skipping the rendering of offscreen content
new MinimogTheme.delayToUserInteraction(() => {
  document.body.removeAttribute("data-page-rendering");
});

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
  MinimogTheme.config.mqlMobile = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent("matchMobile"));
    } else {
      MinimogTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent("unmatchMobile"));
    }
  };

  // Tablet
  const mqltl = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
  MinimogTheme.config.mqlTablet = mqltl.matches;
  mqltl.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent("matchTablet"));
    } else {
      MinimogTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent("unmatchTablet"));
    }
  };
})();

class Tabs {
  constructor(container, cb = () => {}) {
    this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    };
    this.activeClass = "active";
    this.currentActiveIndex = -1;
    this.currentTab = null;
    this.container = container;
    this.cb = cb;
    this.domNodes = queryDomNodes(this.selectors, container);
    this.customSelect = this.container.querySelector("m-select-component");

    this.init();
    this.setActiveTab(0);
  }

  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, tabHeader) => {
        e.preventDefault();
        let index;
        if (tabHeader) {
          index = Number(tabHeader.dataset.index);
        }
        this.setActiveTab(index);
        this.cb(tabHeader);
      },
    });
  }

  setActiveTab(tabIndex) {
    const { tabHeaders, tabContents } = this.domNodes;

    if (tabContents.length && tabIndex !== -1 && this.currentActiveIndex !== tabIndex) {
      let currHeader, newHeader, newTab;

      currHeader = tabHeaders && tabHeaders[this.currentActiveIndex];
      newHeader = tabHeaders && tabHeaders[tabIndex];

      if (this.customSelect && newHeader) {
        const tabHeaderStyle = this.customSelect.dataset.tabHeader;
        tabHeaderStyle === "select" && this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        if (MinimogTheme.config.mqlMobile) {
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        }
        document.addEventListener("matchMobile", () =>
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML)
        );
      }

      newTab = tabContents && tabContents[tabIndex];

      currHeader && currHeader.classList.remove(this.activeClass);
      this.currentTab && this.currentTab.classList.remove(this.activeClass);

      newHeader && newHeader.classList.add(this.activeClass);
      newTab && newTab.classList.add(this.activeClass);

      setTimeout(() => (newTab.style.opacity = 1));

      this.currentActiveIndex = tabIndex;
      this.currentTab = newTab;
    }
  }
}
window.MinimogTheme.Tabs = Tabs;

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "minimog:check";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(url, config = getRequestDefaultConfigs()) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

const cache = new Map();
function fetchCache(url, config = getRequestDefaultConfigs()) {
  return new Promise((resolve, reject) => {
    let cached = cache.get(url);
    if (cached) return resolve(cached);
    fetch(url, config)
      .then((res) => {
        cached = res.text();
        cache.set(url, cached);
        resolve(cached);
      })
      .catch(reject);
  });
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;
  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, getRequestDefaultConfigs())
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const div = generateDomFromString(html);
        sectionCache.set(url, div);
        resolve(div);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

const cache2 = new Map();
function fetchJsonCache(url, config = requestDefaultConfigs) {
  return new Promise((resolve, reject) => {
    if (cache2.get(url)) {
      return resolve(cache2.get(url));
    }
    fetch(url, config)
      .then((res) => {
        if (res.ok) {
          const json = res.json();
          resolve(json);
          cache2.set(url, json);
          return json;
        } else {
          reject(res);
        }
      })
      .catch(reject);
  });
}

function formatMoney(cents, format) {
  const moneyFormat = "${{amount}}";
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function validateForm(form) {
  const missingFields = [];
  if (!form) return missingFields;
  const fieldSelectors = '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
  const requiredFields = form.querySelectorAll(fieldSelectors);
  requiredFields.forEach((field) => {
    field.classList.remove("form-control--warning");
    if (field.type === "radio") {
      const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
      const selected = Array.from(buttons).some((btn) => btn.checked);
      if (!selected) {
        missingFields.push(field);
        field.classList.add("form-control--warning");
      }
    } else if (!field.value) {
      missingFields.push(field);
      field.classList.add("form-control--warning");
    }
  });
  return missingFields;
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function generateDomeFromStringNew(value, selector = "div") {
  const dom = new DOMParser().parseFromString(value, "text/html");
  const newDom = dom.querySelector(selector);
  return newDom;
}

function fetchCountDown(collectionID) {
  const appURL = MinimogSettings.foxKitBaseUrl ? `https://${MinimogSettings.foxKitBaseUrl}` : "";

  return new Promise((resolve, reject) => {
    let requestUrl = `${appURL}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${collectionID}`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });
}

function loadAssets(files = [], id, callback = () => {}, options = {}) {
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.MinimogLibs.loadjs.isDefined(id)) window.MinimogLibs.loadjs(files, unique);
  window.MinimogLibs.loadjs.ready(unique, callback);
}

function pauseAllMedia(container = document) {
  container.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  container.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  container.querySelectorAll("video").forEach((video) => video.pause());
  container.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function loadJS(src, target = document.body, async = false, defer = true) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}

function loadCSS(href, target = document.head) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}

function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}

function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + " is empty.");
  }
}

function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function (variant) {
    return options.every(function (option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + "_" + size + suffix);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

function updateParam(key, value) {
  var { location } = window;
  var baseUrl = [location.protocol, "//", location.host, location.pathname].join("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has(key)) {
    if (value !== "" && value !== "undefined") {
      urlParams.set(key, value);
    }
    if (value === "" || value === "undefined") {
      urlParams.delete(key);
    }
  } else {
    if (value) urlParams.append(key, value);
  }

  window.history.replaceState({}, "", baseUrl + "?" + urlParams.toString());
  return false;
}

function createSearchLink(query) {
  const searchParams = new URLSearchParams({
    type: "product",
    ["options[unavailable_products]"]: "last",
    ["options[prefix]"]: "last",
    q: query,
  });

  const searchURL = window.MinimogSettings.routes.search_url;
  return `${searchURL}?${searchParams.toString()}`;
}

function refreshProductReview() {
  if (typeof SMARTIFYAPPS !== "undefined" && SMARTIFYAPPS.rv.installed) {
    SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
  }
  if (typeof Yotpo !== "undefined" && typeof Yotpo.API === "function") {
    const yotpoApi = new Yotpo.API(yotpo);
    yotpoApi?.refreshWidgets();
  }
}

function reInitTooltip(container) {
  const tooltips = container && container.querySelectorAll("[data-tippy-content]");
  tooltips &&
    tooltips.forEach((tooltip) => {
      MinimogLibs.Tooltip(tooltip, {
        animation: "shift-toward",
        touch: false,
        hideOnClick: false,
        onCreate(instance) {
          const theme = instance.reference.dataset.tippyTheme || "m-color-background-1";
          if (
            instance.reference.classList.contains("m-wishlist-button") ||
            instance.reference.classList.contains("m-compare-button")
          ) {
            instance.setProps({
              hideOnClick: false,
            });
          }
          instance.setProps({
            theme: theme,
          });

          let dataPlacement = instance.reference.getAttribute("data-tippy-placement");
          if (MinimogTheme.config.isRTL && dataPlacement) {
            if (dataPlacement.includes("left")) {
              instance.setProps({
                placement: dataPlacement.replace("left", "right"),
              });
            } else if (dataPlacement.includes("right")) {
              instance.setProps({
                placement: dataPlacement.replace("right", "left"),
              });
            }
          }
        },
      });
    });
}

// SetPopularSearchLink
(function () {
  const popularSearchItems = document.querySelectorAll("[data-ps-item]");
  if (popularSearchItems) {
    popularSearchItems.forEach((itm) => (itm.href = createSearchLink(itm.dataset.psQuery)));
  }
})();

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function getScrollbarWidth() {
  // When not has scrollbar.
  if (window.innerWidth <= document.documentElement.clientWidth) {
    return 0;
  }

  // Creating invisible container.
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; // forcing scrollbar to appear.
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps.
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container.
  const inner = document.createElement("div");
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width.
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM.
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

function spinner(className = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>`;
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function formatUrl(pageType, handle, query) {
  let url;
  const { routes } = MinimogSettings;
  const root = routes.root.endsWith("/") ? "" : routes.root;
  url = `${root}/${pageType}/${handle}`;
  if (query) url += `?${query}`;
  return url;
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    this.autoPlay = this.dataset.autoPlay === "true";
    if (!this.autoPlay) window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      this.deferredElement = deferredElement;

      if (focus) deferredElement.focus();
      this.playVideo(deferredElement);
    }
  }

  playVideo(videoElm) {
    if (videoElm.classList.contains("js-youtube")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&mute=1";
    } else if (videoElm.classList.contains("js-vimeo")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&muted=1";
    } else {
      videoElm.setAttribute("autoplay", "autoplay");
      videoElm.play();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slideControls: ".m-slider-controls",
      slideContainer: ".m-mixed-layout__wrapper", // slideContainer
    };

    this.enableSlider = this.dataset.enableSlider === "true";
    this.showPagination = this.dataset.showPagination === "true";
    this.showNavigation = this.dataset.showNavigation === "true";
    this.paginationType = this.dataset.paginationType || "bullets";
    this.mobileLayout = this.dataset.mobileLayout;
    this.items = this.dataset.items;
    this.laptopItems = this.dataset.laptopItems;
    this.tabletItems = this.dataset.tabletItems;
    this.mobileItems = this.dataset.mobileItems || 2;

    this.container = this.closest(".m-section");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.totalProducts = recommendations.querySelectorAll(".m-product-card").length;

            if (this.products <= 0) {
              this.container && this.container.classList.add("m:hidden");
            }

            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            MinimogTheme.CompareProduct.setCompareButtonsState();
            MinimogTheme.Wishlist.setWishlistButtonsState();

            // Init tooltip
            reInitTooltip(this);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
  }

  initByScreenSize() {
    const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

    if (this.enableSlider) {
      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    if (!this.enableSlider || this.totalProducts <= parseInt(this.items)) {
      slideControls && slideControls.classList.add("m:hidden");
    }
  }

  initSlider() {
    const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);
    const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
    const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

    slideContainer && slideContainer.classList.add("swiper");

    let __this = this;

    this.slider = new MinimogLibs.Swiper(slideContainer, {
      modules: MinimogTheme.config.swiperModules,
      slidesPerView: parseInt(this.mobileItems),
      slidesPerGroup: 1,
      loop: this.totalProducts <= parseInt(this.items) ? false : true,
      navigation: this.showNavigation
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      pagination: this.showPagination
        ? {
            el: this.querySelector(".swiper-pagination"),
            type: this.paginationType,
            clickable: true,
          }
        : false,
      breakpoints: {
        768: {
          slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
        },
        1024: {
          slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
        },
        1280: {
          slidesPerView: parseInt(this.items),
        },
      },
      threshold: 2,
      on: {
        init: function () {
          setTimeout(() => {
            // Calculate controls position
            const firstCard = __this.querySelector(".m-product-card");

            if (firstCard && slideControls) {
              const firstImage = firstCard.querySelector(".m-image");
              const prevButton = slideControls.querySelector(".m-slider-controls__button-prev");
              const nextButton = slideControls.querySelector(".m-slider-controls__button-next");
              const cardOffsetTop = window.getComputedStyle(firstCard).getPropertyValue("padding-top");
              const buttonHeight = prevButton.offsetHeight;
              const itemHeight = firstImage.clientHeight;

              slideControls.style.setProperty("--nav-offset-top", parseInt(itemHeight) / 2 + "px");
              slideControls.style.setProperty(
                "--nav-transform",
                (-1 * parseInt(buttonHeight)) / 2 + parseInt(cardOffsetTop) + "px"
              );

              setTimeout(() => {
                prevButton.classList.remove("m:opacity-0");
                nextButton.classList.remove("m:opacity-0");
              }, 150);
            }
          }, 100);
        },
      },
    });

    this.swiper = slideContainer && slideContainer.swiper;
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slideControls: ".m-slider-controls",
      slideContainer: ".m-mixed-layout__wrapper", // slideContainer
    };

    this.enableSlider = this.dataset.enableSlider === "true";
    this.showNavigation = this.dataset.showNavigation === "true";
    this.items = this.dataset.items;
    this.laptopItems = this.dataset.laptopItems;
    this.tabletItems = this.dataset.tabletItems;
    this.mobileItems = this.dataset.mobileItems || 2;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const complementary = html.querySelector("complementary-products");
          if (complementary && complementary.innerHTML.trim().length) {
            this.innerHTML = complementary.innerHTML;
            this.totalProducts = complementary.querySelectorAll(".m-product-card").length;

            this.initSlider();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
  }

  initSlider() {
    if (!this.enableSlider || this.totalProducts <= this.items) return;

    const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);
    const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
    const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

    slideContainer && slideContainer.classList.add("swiper");

    const swiperModules = [...MinimogTheme.config.swiperModules, MinimogLibs.Swiper.Grid];

    this.slider = new MinimogLibs.Swiper(slideContainer, {
      modules: swiperModules,
      slidesPerView: 1,
      slidesPerGroup: 1,
      grid: {
        rows: parseInt(this.dataset.rows) || 1,
        fill: "row",
      },
      navigation: this.showNavigation
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "fraction",
        clickable: true,
      },
      threshold: 2,
    });
  }
}
customElements.define("complementary-products", ComplementaryProducts);

if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends HTMLElement {
      constructor() {
        super();
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      }

      init() {
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        poster.addEventListener("click", this.loadContent.bind(this));
      }

      loadContent() {
        if (!this.getAttribute("loaded")) {
          const content = document.createElement("div");
          content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

          this.setAttribute("loaded", true);
          const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
          this.deferredElement = deferredElement;

          if (this.deferredElement.classList.contains("js-youtube")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1`;
          } else if (this.deferredElement.classList.contains("js-vimeo")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1`;
          } else {
            this.deferredElement.play();
          }
        }
      }
    }
  );
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      const destroy = this.dataset.destroy === "true";
      if (destroy) return;

      this.setDefaultData();
      this.attachEvents();

      if (this.getAttribute("open") === "true") {
        this.selected = true;
        this.classList.add(this.expandedClass);
        this.setExpandedAria();
      } else {
        this.content.style.height = this.collapsedHeight;
        this.classList.add(this.collapsedClass);
        this.setCollapsedAria();
      }
      this.content.removeAttribute("hidden");
    }

    transitionendEventName() {
      let i,
        el = document.createElement("div"),
        transitions = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    }

    expand() {
      const resetHeight = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (!this.isOpen) return;

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = "auto";

          requestAnimationFrame(() => {
            this.content.style.height = null;
            this.content.style.transition = null;

            this.setExpandedAria();
            this.classList.add(this.expandedClass);
            this.trySetTabIndex(this.content, 0);

            this.fire("tabOpened");
          });
        });
      };

      const bindEvent = resetHeight.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = true;
      this.classList.remove(this.collapsedClass);
      this.content.style.height = this.content.scrollHeight + "px";
    }

    collapse() {
      const endTransition = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (this.isOpen) return;

        this.fire("elementClosed");
        this.setCollapsedAria();
        this.classList.add(this.collapsedClass);
        this.trySetTabIndex(this.content, -1);
      };

      const bindEvent = endTransition.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = false;
      this.classList.remove(this.expandedClass);

      requestAnimationFrame(() => {
        this.content.style.transition = "0";
        this.content.style.height = this.content.scrollHeight + "px";

        requestAnimationFrame(() => {
          this.content.style.transition = null;
          this.content.style.height = this.collapsedHeight;
        });
      });
    }

    open() {
      this.selected = true;
      this.fire("elementSelected");
      this.expand();
      this.setAttribute("open", true);
      console.log("elementSelected");
    }

    close() {
      console.log("elementUnselected");
      this.selected = false;
      this.fire("elementUnselected");
      this.collapse();
      this.removeAttribute("open");
    }

    toggle(event) {
      event.preventDefault();
      if (this.selected) {
        this.close();
      } else {
        this.open();

        if (this.oneAtATime) {
          const allItems = document.querySelectorAll("collapsible-tab");
          const parent = this.closest("[data-first-level]");
          if (allItems.length) {
            allItems.forEach((item) => {
              if (item !== this && item.selected && parent !== item) {
                item.close();
              }
            });
          }
        }
      }
    }

    trySetTabIndex(el, index) {
      const tappableElements = el.querySelectorAll(this.defaultElements);
      if (tappableElements) {
        tappableElements.forEach((e) => {
          e.setAttribute("tabindex", index);
        });
      }
    }

    setExpandedAria() {
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
    }

    setCollapsedAria(el) {
      this.trigger.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
    }

    attachEvents() {
      this.trigger.addEventListener("click", (event) => this.toggle(event));
    }

    setDefaultData() {
      this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      };
      this.transitionendevent = this.transitionendEventName();
      this.expandedClass = "is-expanded";
      this.collapsedClass = "is-collapsed";
      this.trigger = this.querySelector("[data-trigger]");
      this.content = this.querySelector("[data-content]");
      this.collapsedHeight = "0px";
      this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"];
      this.oneAtATime = true;
      if (this.dataset.oneOpen) {
        this.oneAtATime = this.dataset.oneOpen === "true";
      }
    }

    fire(eventName) {
      let callbacks = this.events[eventName];
      if (callbacks) {
        for (let i = 0; i < callbacks.length; i++) {
          callbacks[i](this);
        }
      }
    }

    on(eventName, cb) {
      if (!this.events[eventName]) return;
      this.events[eventName].push(cb);
    }

    destroy() {
      this.trigger.removeEventListener("click", (event) => this.toggle(event));
      this.content.removeAttribute("aria-hidden");
      this.content.style.height = "auto";
      this.classList.remove(this.expandedClass, this.collapsedClass);
      this.removeAttribute("open");
    }
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".swiper",
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.pagination = this.dataset.pagination === "true";
      this.navigation = this.dataset.navigation === "true";
      this.autoplay = this.dataset.autoplay === "true" || false;
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5;
      this.effect = this.dataset.effect;
      this.showContentBelow = this.dataset.showContentBelow === "true";
      this.initSlider();
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      this.controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton =
        this.controlsContainer && this.controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        this.controlsContainer && this.controlsContainer.querySelector(".m-slider-controls__button-next");

      const swiperModules = [
        ...MinimogTheme.config.swiperModules,
        MinimogLibs.Swiper.EffectFade,
        MinimogLibs.Swiper.Autoplay,
      ];

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: swiperModules,
        slidesPerView: 1,
        loop: true,
        slidesPerGroup: 1,
        effect: this.effect,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: false,
            }
          : false,
        navigation: this.navigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.pagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: "fraction",
              clickable: true,
            }
          : false,
        on: {
          init: (swiper) => {
            const currentSlide = swiper.slides[swiper.activeIndex];
            const currentContent = currentSlide.querySelector(".m-slide__content");
            this.currentColorScheme = currentContent && currentContent.dataset.colorScheme;
            this.controlsContainer && this.controlsContainer.classList.add(this.currentColorScheme);
          },
        },
        threshold: 2,
      });

      this.slider.on("slideChange", (swiper) => {
        this.onSlideChange(swiper);
        document.addEventListener("matchMobile", () => {
          this.onSlideChange(swiper);
        });
        document.addEventListener("unmatchMobile", () => {
          this.onSlideChange(swiper);
        });
      });

      if (this.showContentBelow) {
        this.setColorScheme();
        document.addEventListener("matchMobile", () => {
          this.setColorScheme();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setColorScheme();
        });
      }

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onSlideChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideActive = slides[activeIndex];
      const slideContentActive = slideActive && slideActive.querySelector(".m-slide__content");
      const colorSchemeActive = slideContentActive && slideContentActive.dataset.colorScheme;
      if (!MinimogTheme.config.mqlMobile || !this.showContentBelow) {
        this.controlsContainer && this.controlsContainer.classList.remove(this.currentColorScheme);
        this.controlsContainer && this.controlsContainer.classList.add(colorSchemeActive);
        this.currentColorScheme = colorSchemeActive;
      }
    }

    setColorScheme() {
      const slideContents = this.querySelectorAll(".m-slide__content");
      if (MinimogTheme.config.mqlMobile) {
        slideContents.forEach((slideContent) => slideContent.classList.add("m-color-background-1"));
        this.controlsContainer && this.controlsContainer.classList.remove(this.currentColorScheme);
        this.controlsContainer && this.controlsContainer.classList.add("m-color-background-1");
      } else {
        slideContents.forEach((slideContent) => slideContent.classList.remove("m-color-background-1"));
        this.controlsContainer && this.controlsContainer.classList.remove("m-color-background-1");
        this.controlsContainer && this.controlsContainer.classList.add(this.currentColorScheme);
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.index);
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}

if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();
      this.design = this.dataset.design;
      this.containerType = this.dataset.container;
      this.autoplay = this.dataset.autoplay === "true";
      this.container = this.closest(".m-testimonials");
      this.sliderContainer = this.querySelector(".swiper");
    }

    connectedCallback() {
      this.defaultSettings = {
        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.container.querySelector(".m-slider-controls__button-next"),
          prevEl: this.container.querySelector(".m-slider-controls__button-prev"),
        },
        autoplay: this.autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
              disableOnInteraction: false,
            }
          : false,
        loop: true,
        slidesPerView: 1,
        threshold: 2,
      };

      this.settings = {};
      let gutter = 400;
      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: true,
            centeredSlidesBounds: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 300,
            slideToClickedSlide: true,
            loop: true,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 20,
                speed: 1000,
              },
              1280: {
                slidesPerView: 5,
                slidesPerGroup: 3,
                spaceBetween: 30,
              },
              1920: {
                slidesPerView: 7,
                slidesPerGroup: 3,
              },
            },
          };
          break;
        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3 },
            },
          };
          break;
        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: this.containerType === "full-width" ? 3 : 2 },
            },
          };
          break;
        case "testimonials-4":
          if (this.containerType === "full-width") gutter = 200;
          if (this.containerType === "grid") gutter = 150;
          this.settings = {
            slidesPerView: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            slideToClickedSlide: true,
            loop: true,
            pagination: {
              el: this.container.querySelector(".swiper-pagination"),
              clickable: true,
              type: "fraction",
            },
            breakpoints: {
              768: { spaceBetween: parseInt(gutter / 4), slidesPerView: 3 },
              992: { spaceBetween: gutter / 2, slidesPerView: 3 },
              1920: { spaceBetween: gutter, slidesPerView: 3 },
            },
          };
          break;
        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            loop: true,
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
            breakpoints: {
              768: { slidesPerView: 2 },
              1366: { slidesPerView: this.containerType === "grid" ? 2 : 3 },
              1600: { slidesPerView: this.containerType === "grid" ? 2 : 4 },
            },
          };
          break;
        case "testimonials-5":
          this.settings = {
            fade: {
              crossFade: true,
            },
          };
          break;
      }

      // Testimonials 5
      const images = this.querySelector(".m-tabs");
      if (images) {
        const interval = setInterval(() => {
          if (MinimogTheme.Tabs) {
            clearInterval(interval);
            this.imagesTab = new MinimogTheme.Tabs(images);
          }
        }, 50);
      }

      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        modules: [...MinimogTheme.config.swiperModules, MinimogLibs.Swiper.Manipulation, MinimogLibs.Swiper.Autoplay],
        ...this.defaultSettings,
        ...this.settings,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      if (this.design === "testimonials-5") {
        this.slider.on("slideChange", (swiper) => {
          const { realIndex } = swiper;
          this.imagesTab.setActiveTab(realIndex);
        });
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.index);
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}

if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls?.classList.add("m:hidden");
        slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls?.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");

      slideContainer?.classList.add("swiper");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 2,
        slidesPerGroup: 1,
        loop: true,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            loopedSlides: parseInt(this.items) * 4,
          },
        },
        threshold: 2,
      });

      this.swiper = slideContainer?.swiper;
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}

if (!customElements.get("m-multiple-columns")) {
  class MMultipleColumns extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.pagination = this.dataset.pagination === "true";
      this.navigation = this.dataset.navigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.mobileLayout = this.dataset.mobileLayout;
      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls?.classList.add("m:hidden");
        slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls?.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");

      slideContainer?.classList.add("swiper");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 1,
        loop: true,
        slidesPerGroup: 1,
        navigation: this.navigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.pagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.items >= 3 ? 3 : this.items,
          },
          1280: {
            slidesPerView: this.items,
          },
        },
      });

      this.swiper = slideContainer?.swiper;
    }
  }

  customElements.define("m-multiple-columns", MMultipleColumns);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".m-product-form-message",
          customFields: ["[data-product-custom-field]"],
          dynamicCheckout: ".m-product-dynamic-checkout",
        };
      }
      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.cart = document.querySelector("m-cart-drawer");
        this.cartPage = document.querySelector("m-cart");
        this.customFields = document.querySelectorAll(this.selectors.customFields);
        if (this.domNodes.dynamicCheckout) this.enable_dynamic_checkout = true;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        if (this.domNodes.dynamicCheckout && this.customFields) {
          this.domNodes.dynamicCheckout.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.form.closest(".m-main-product__info"));
              if (missing && missing.length > 0) {
                e.stopPropagation();
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: window.MinimogStrings.requiredField,
                  delay: 100,
                });
                console.warn("Missing field(s): ", missing);
              }
            },
            true
          );
        }
      }
      toggleSpinner(show) {
        const method = show ? "add" : "remove";
        this.classList[method]("m-spinner-loading");
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        this.toggleSpinner(true);
        const missing = validateForm(this.form.closest(".m-main-product__info"));

        if (missing && missing.length > 0) {
          console.warn("Missing field(s): ", missing);
          this.toggleSpinner(false);
          return window.MinimogTheme.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.MinimogStrings.requiredField,
          });
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        const { MinimogSettings, MinimogStrings } = window;
        fetch(`${MinimogSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.error = true;
              return window.MinimogTheme.Notification.show({
                target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                method: "appendChild",
                type: "warning",
                message: response.message,
                last: 3000,
                sticky: !this.domNodes.errorWrapper,
              });
            }
            if (MinimogSettings.use_ajax_atc) {
              if (this.cart && MinimogSettings.enable_cart_drawer) {
                this.cart.renderContents(response);
                MinimogTheme.Notification.show({
                  target: this.cart.querySelector("m-cart-drawer-items"),
                  method: "prepend",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  delay: 400,
                });
                window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
              } else {
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
                fetchJSON(window.Shopify.routes.root + "cart.json").then((cart) => {
                  if (cart) {
                    const count = cart.item_count;
                    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
                    cartCounts.forEach((cartCount) => {
                      if (count > 0) {
                        cartCount.textContent = count;
                        cartCount.classList.remove("m:hidden");
                      } else {
                        cartCount.classList.add("m:hidden");
                      }
                    });
                  }
                });
              }
            } else {
              window.location = MinimogSettings.routes.cart;
            }
            this.error = false;
            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
            document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true, detail: response }));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.toggleSpinner(false);
            if (this.cart) {
              const cartDrawerItems = this.cart.querySelector("m-cart-drawer-items");
              if (this.cart.classList.contains("m-cart--empty")) this.cart.classList.remove("m-cart--empty");
              if (cartDrawerItems && cartDrawerItems.classList.contains("m-cart--empty"))
                cartDrawerItems.classList.remove("m-cart--empty");
            }
            if (this.cartPage) {
              if (this.cartPage.classList.contains("m-cart--empty")) this.cartPage.classList.remove("m-cart--empty");
            }
          });
      }
    }
  );
}

if (!customElements.get("m-press")) {
  class MPress extends HTMLElement {
    constructor() {
      super();
      this.prevSlideIndex = 0;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const contentWrapper = this.querySelector(".m-press__content");
      const navWrapper = this.querySelector(".m-press__list .swiper");
      const autoplay = this.dataset.autoplay === "true";

      this.items = parseInt(this.dataset.items);
      this.canLoop = window.innerWidth < 1300 ? this.items > 3 : this.items > 5;

      this.contentSlider = new MinimogLibs.Swiper(contentWrapper, {
        modules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination, MinimogLibs.Swiper.Thumbs],
        slidesPerView: 1,
        allowTouchMove: false,
        fadeEffect: {
          crossFade: true,
        },
      });

      this.navSlider = new MinimogLibs.Swiper(navWrapper, {
        modules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination, MinimogLibs.Swiper.Thumbs],
        autoplay: autoplay
          ? {
              delay: 5000,
            }
          : false,
        items: 1,
        loop: this.canLoop,
        centeredSlides: this.canLoop,
        threshold: 2,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        slideToClickedSlide: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            navigation: false,
          },
          1280: {
            slidesPerView: 5,
            navigation: false,
          },
        },
        on: {
          init: function (swiper) {
            const firstSlide = swiper.slides[swiper.activeIndex];
            firstSlide && firstSlide.classList.add("m-press__logo--is-active");
          },
        },
      });

      !this.canLoop && this.navSlider.on("click", this._handleClick.bind(this));
      this.navSlider.on("slideChange", this._handleChange.bind(this));

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    _handleChange(swiper) {
      const { realIndex, activeIndex, slides } = swiper || {};

      const prevSlide = this.querySelector('.m-press__logo--is-active[data-index="' + this.prevSlideIndex + '"]');
      const currentSlide = slides[activeIndex];

      currentSlide && currentSlide.classList.add("m-press__logo--is-active");
      prevSlide && prevSlide.classList.remove("m-press__logo--is-active");

      // Change content slide
      this.contentSlider.slideTo(realIndex);
      // Set prev slide index
      this.prevSlideIndex = realIndex;
    }

    _handleClick(swiper) {
      const { clickedIndex, clickedSlide } = swiper || {};

      const prevSlide = this.querySelector('.m-press__logo--is-active[data-index="' + this.prevSlideIndex + '"]');

      clickedSlide && clickedSlide.classList.add("m-press__logo--is-active");
      prevSlide && prevSlide.classList.remove("m-press__logo--is-active");

      // Change content slide
      this.contentSlider.slideTo(clickedIndex);
      // Set prev slide index
      this.prevSlideIndex = clickedIndex;
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      if (this.contentSlider) {
        this.contentSlider.slideToLoop(index);
      }
      if (this.navSlider) {
        this.navSlider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-press", MPress);
}

if (!customElements.get("m-featured-slider")) {
  class MFeaturedSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        sliderContainer: ".m-featured-slider__products",
        slideImages: ["m-featured-slider__img"],
        slideImagesContainer: ".m-featured-slider__images",
        sliderControls: ".m-slider-controls",
        prevBtn: ".m-slider-controls__button-prev",
        nextBtn: ".m-slider-controls__button-next",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const showNavigation = this.dataset.showNavigation === "true";
      const showPagination = this.dataset.showPagination === "true";
      const autoplay = this.dataset.autoplay === "true";
      const timeout = this.dataset.timeout;

      const slideModules = [
        ...MinimogTheme.config.swiperModules,
        MinimogLibs.Swiper.Thumbs,
        MinimogLibs.Swiper.Autoplay,
      ];

      this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
        modules: slideModules,
        speed: 400,
        loop: true,
        autoplay: autoplay
          ? {
              delay: parseInt(timeout),
              disableOnInteraction: false,
            }
          : false,
        pagination: showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: "bullets",
              clickable: true,
            }
          : false,
        navigation: {
          nextEl: this.domNodes.nextBtn,
          prevEl: this.domNodes.prevBtn,
        },
      });

      // Sync 2 sliders
      this.imageSlider = new MinimogLibs.Swiper(this.domNodes.slideImagesContainer, {
        modules: slideModules,
        speed: 500,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      this.slider.on("activeIndexChange", (swiper) => {
        const { realIndex } = swiper;
        this.imageSlider.slideToLoop(realIndex);
      });

      this.imageSlider.on("activeIndexChange", (swiper) => {
        const { realIndex } = swiper;
        this.slider.slideToLoop(realIndex);
      });

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      if (this.slider) this.slider.slideToLoop(index);
      if (this.imageSlider) this.imageSlider.slideToLoop(index);
    }
  }

  customElements.define("m-featured-slider", MFeaturedSlider);
}

if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}

if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        countDown: "[data-flash-sale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);
      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

      slideContainer && slideContainer.classList.add("swiper");

      let __this = this;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        loop: this.enableFlashsale ? false : true,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstCard = __this.querySelector(".m-product-card");

              if (firstCard && slideControls) {
                const firstImage = firstCard.querySelector(".m-image") || firstCard.querySelector(".m-placeholder-svg");
                const prevButton = slideControls.querySelector(".m-slider-controls__button-prev");
                const nextButton = slideControls.querySelector(".m-slider-controls__button-next");
                const cardOffsetTop = window.getComputedStyle(firstCard).getPropertyValue("padding-top");
                const buttonHeight = prevButton.offsetHeight;
                const itemHeight = firstImage.clientHeight;

                slideControls.style.setProperty("--nav-offset-top", parseInt(itemHeight) / 2 + "px");
                slideControls.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(buttonHeight)) / 2 + parseInt(cardOffsetTop) + "px"
                );

                setTimeout(() => {
                  prevButton.classList.remove("m:opacity-0");
                  nextButton.classList.remove("m:opacity-0");
                }, 150);
              }
            }, 100);
          },
        },
      });

      this.swiper = slideContainer && slideContainer.swiper;
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}

if (!customElements.get("m-banner-with-slide")) {
  class MBannerWithSlide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.lastActive = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(`.m-slider-${this.dataset.id}`, {
        modules: MinimogTheme.config.swiperModules,
        autoplay:
          this.dataset.autoplay === "true" ? { delay: this.dataset.timeout, disableOnInteraction: true } : false,
        slidesPerView: 1,
        // loop: true,
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
          },
        },
      });
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-banner-with-slide", MBannerWithSlide);
}

if (!customElements.get("m-brand-list")) {
  class MBrandList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      const wrapper = this.querySelector("[data-wrapper]");

      if (MinimogTheme.config.mqlMobile) {
        wrapper.classList.add("swiper-wrapper");
        this.initSlider();
      } else {
        wrapper.classList.remove("swiper-wrapper");
        this.slider && this.slider.destroy(true, true);
      }

      document.addEventListener("matchMobile", () => {
        wrapper.classList.add("swiper-wrapper");
        this.initSlider();
      });

      document.addEventListener("unmatchMobile", () => {
        wrapper.classList.remove("swiper-wrapper");
        this.slider && this.slider.destroy(true, true);
      });
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);
      const slideContainer = this.querySelector(".swiper");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          modules: MinimogTheme.config.swiperModules,
          slidesPerView: items,
          slidesPerGroup: items,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          // loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      }
    }
  }

  customElements.define("m-brand-list", MBrandList);
}

if (!customElements.get("m-custom-content")) {
  class MCustomContent extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        bundleError: ".product-bundles__error",
        productBundles: [".product-bundles"],
        productVariantSelects: ".m-product-option--dropdown-select",
        totalPrice: "[data-total-price]",
        submitBundle: "[data-add-bundle]",
        errorWrapper: ".product-bundles__error",
        cartDrawer: "m-cart-drawer",
      };

      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      if (this.domNodes.productBundles) this.initProductBundles();
    }

    initProductBundles() {
      this.domNodes.productBundles.length &&
        this.domNodes.productBundles.map((bundle) => {
          let allProducts = [],
            productVariants = [];
          const products = bundle.querySelectorAll(".product-bundles__item");

          for (let product of products) {
            let variants = product.nextElementSibling.innerHTML;
            variants = JSON.parse(variants);

            productVariants.push(variants);
            allProducts.push(product);

            addEventDelegate({
              context: product,
              event: "change",
              selector: this.selectors.productVariantSelects,
              handler: (e) => this._handleChangePrice(e, product, variants, allProducts),
            });
          }

          addEventDelegate({
            context: bundle,
            selector: this.selectors.submitBundle,
            handler: (e) => this._handleAddItems(e, bundle),
          });
        });
    }

    _handleChangePrice(evt, product, variants, products) {
      const regularPrice = product.querySelector("[data-regular-price]");
      let comparePrice = product.querySelector("[data-compare-price]");
      let savedPrice = product.querySelector("[data-saved-price]");
      let savedPriceWrapper = product.querySelector(".product-bundles__save-price");

      const selectedVariant = evt.target.value;
      const variant = variants.find((v) => v.id === parseInt(selectedVariant));

      regularPrice.innerHTML = formatMoney(variant.price, MinimogSettings.money_format);
      regularPrice.dataset.price = variant.price;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (comparePrice) {
          comparePrice.classList.remove("m:hidden");
          comparePrice.innerHTML = formatMoney(variant.compare_at_price, MinimogSettings.money_format);
        }
        if (savedPriceWrapper) {
          savedPriceWrapper.classList.remove("m:hidden");
        }
        if (savedPrice) {
          savedPrice.classList.remove("m:hidden");
          savedPrice.innerHTML = formatMoney(variant.compare_at_price - variant.price, MinimogSettings.money_format);
        }
      } else {
        if (comparePrice) {
          comparePrice.classList.add("m:hidden");
        }
        if (savedPriceWrapper) {
          savedPriceWrapper.classList.add("m:hidden");
        }
        if (savedPrice) {
          savedPrice.classList.add("m:hidden");
        }
      }

      // Calculate total price
      const selectedVariants = products
        .map((product) => {
          let variants = product.nextElementSibling.innerHTML;
          variants = JSON.parse(variants);

          let select = product.querySelector('[name="id"]');
          if (variants && select) {
            return variants.find((v) => v.id === Number(select.value));
          }
        })
        .filter(Boolean);

      const totalPrice = selectedVariants.reduce((s, v) => s + v.price, 0);
      const container = product.closest(".product-bundles");
      container.querySelector(this.selectors.totalPrice).innerHTML = formatMoney(
        totalPrice,
        MinimogSettings.money_format
      );
    }

    _handleAddItems(e, bundle) {
      e.preventDefault();
      const inputIds = bundle.querySelectorAll('[name="id"]');
      const errorWrapper = bundle.querySelector(this.selectors.errorWrapper);
      const button = bundle.querySelector(this.selectors.submitBundle);
      const cartDrawrer = document.querySelector(this.selectors.cartDrawer);

      const ids = [...inputIds].map((input) => input.value);
      let data = { items: ids.map((id) => ({ id, quantity: 1 })) };
      if (cartDrawrer) {
        data = {
          ...data,
          sections: cartDrawrer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        };
      }
      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify(data);

      this._toggleLoading(true, button);
      const { MinimogSettings, MinimogStrings } = window;
      fetch(`${MinimogSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this._showError(response.description || "Failed to add all items to cart!", errorWrapper);
            return;
          }
          if (MinimogSettings.use_ajax_atc) {
            if (!MinimogSettings.enable_cart_drawer) {
              window.MinimogTheme.Notification.show({
                target: errorWrapper ? errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: MinimogStrings.itemAdded,
                last: 3000,
                sticky: !this.domNodes.errorWrapper,
              });
            } else {
              cartDrawrer && cartDrawrer.renderContents(response);
              MinimogTheme.Notification.show({
                target: cartDrawrer.querySelector("m-cart-drawer-items"),
                method: "prepend",
                type: "success",
                message: MinimogStrings.itemAdded,
                delay: 400,
              });
            }
            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, response);
          } else {
            window.location = MinimogSettings.routes.cart;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this._toggleLoading(false, button);
          if (cartDrawrer) {
            const cartDrawerItems = cartDrawrer.querySelector("m-cart-drawer-items");
            if (cartDrawrer.classList.contains("m-cart--empty")) cartDrawrer.classList.remove("m-cart--empty");
            if (cartDrawerItems && cartDrawerItems.classList.contains("m-cart--empty"))
              cartDrawerItems.classList.remove("m-cart--empty");
          }
        });
    }

    _showError(err, errorWrapper) {
      MinimogTheme.Notification.show({
        target: errorWrapper,
        method: "appendChild",
        type: "warning",
        message: err,
      });
    }
    _toggleLoading(loading, button) {
      if (loading) {
        button.classList.add("m-spinner-loading");
      } else {
        button.classList.remove("m-spinner-loading");
      }
    }
  }

  customElements.define("m-custom-content", MCustomContent);
}

if (!customElements.get("m-gmaps")) {
  class MGmaps extends HTMLElement {
    constructor() {
      super();
      if (!this.dataset.apiKey || !this.dataset.mapAddress) {
        return;
      }
    }

    connectedCallback() {
      this.prepMapApi();
    }

    prepMapApi() {
      this.loadScript().then(this.initMap.bind(this));
    }

    loadScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.dataset.apiKey;
      });
    }

    initMap() {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {
          }
        } else {
          const mapOptions = {
            zoom: parseInt(this.dataset.zoom),
            center: results[0].geometry.location,
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
          };

          const map = new google.maps.Map(this, mapOptions),
            center = map.getCenter();

          map.setCenter(center);

          const icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: this.dataset.markerColor,
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 55),
            strokeWeight: 0,
            scale: 0.6,
          };

          new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: icon,
          });

          const styledMapType = new google.maps.StyledMapType(
            JSON.parse(this.parentNode.querySelector("[data-gmap-style]").innerHTML)
          );

          map.mapTypes.set("styled_map", styledMapType);
          map.setMapTypeId("styled_map");

          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          });
        }
      });
    }
  }

  customElements.define("m-gmaps", MGmaps);
}

if (!customElements.get("m-countdown-timer")) {
  if (!customElements.get("m-countdown-timer")) {
    class MCountdownTimer extends HTMLElement {
      times = ["day", "hour", "min", "sec"];
      selectors = {
        day: "[data-timer-day]",
        hour: "[data-timer-hour]",
        min: "[data-timer-minute]",
        sec: "[data-timer-second]",
      };
      DAY_IN_MS = 24 * 60 * 60 * 1000;
      HOUR_IN_MS = 60 * 60 * 1000;
      MIN_IN_MS = 60 * 1000;
      startTime = Date.now();

      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.countdownTimer) return;
        this.init();
      }

      init = () => {
        this.startTime = Date.now();
        this.savedStartTime = this.startTime;
        this.endTime = new Date(this.dataset.countdownTimer).getTime();
        this.options = {
          addZeroPrefix: true,
          loop: false,
          callback: () => {},
        };

        if (this.endTime < this.startTime) return;
        this.intervalTime = 1000;
        this.timer = null;
        this.domNodes = queryDomNodes(this.selectors, this);
        this.wrapper = this.closest(this.selectors.wrapper);

        this.start();
      };

      start = () => {
        this.timer = setInterval(() => {
          if (this.startTime > this.endTime) this.stop();
          else this.update();
        }, this.intervalTime);

        this.classList.remove("m:hidden");
      };

      update = () => {
        const timeData = this.format(this.endTime - this.startTime);
        this.times.forEach((time) => {
          if (this.domNodes[time]) {
            this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
          }
        });
        this.startTime += this.intervalTime;
      };

      stop = () => {
        clearInterval(this.timer);
        if (this.options.loop) {
          this.startTime = this.savedStartTime;
          this.start();
        } else {
          this.timer = null;
          this.options.callback();
          this.classList.add("f-hidden");
          this.wrapper && this.wrapper.setAttribute("hidden", true);
        }
      };

      clear = () => {
        clearInterval(this.timer);
        this.timer = null;
        this.startTime = this.savedStartTime;
        this.times.forEach((time) => {
          if (this.domNodes[time]) {
            this.domNodes[time].textContent = "00";
          }
        });
      };

      addZeroPrefix = (num) => {
        if (this.options.addZeroPrefix && num < 10) {
          return `0${num}`;
        }
        return num.toString();
      };

      format = (ms) => {
        return {
          day: Math.floor(ms / this.DAY_IN_MS),
          hour: Math.floor(ms / this.HOUR_IN_MS) % 24,
          min: Math.floor(ms / this.MIN_IN_MS) % 60,
          sec: Math.floor(ms / 1000) % 60,
        };
      };
    }

    customElements.define("m-countdown-timer", MCountdownTimer);
  }
}

if (!customElements.get("m-image-comparison")) {
  class MImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
      this.button = this.querySelector("button");
      this.horizontal = this.dataset.layout === "horizontal";
      this.init();
      if (this.hasAttribute("data-animation")) {
        MinimogTheme.initWhenVisible({
          element: this.querySelector(".m-image-comparison__slider-animation"),
          callback: this.animation.bind(this),
          threshold: 0,
        });
      }
    }

    init() {
      this.button.addEventListener("touchstart", this.start.bind(this));
      document.body.addEventListener("touchend", this.end.bind(this));
      document.body.addEventListener("touchmove", this.onStart.bind(this));

      this.button.addEventListener("mousedown", this.start.bind(this));
      document.body.addEventListener("mouseup", this.end.bind(this));
      document.body.addEventListener("mousemove", this.onStart.bind(this));
    }

    animation() {
      this.setAttribute("is-visible", "");
      this.classList.add("m-animating");
      setTimeout(() => {
        this.classList.remove("m-animating");
      }, 1e3);
    }

    start() {
      const scrollbarWidth = getScrollbarWidth();
      document.body.style.setProperty("padding-right", scrollbarWidth + "px");
      document.documentElement.style.setProperty("overflow", "hidden");
      this.active = true;
      this.classList.add("image-comparing");
    }

    end() {
      document.body.style.setProperty("padding-right", 0);
      document.documentElement.style.removeProperty("overflow");
      this.active = false;
      this.classList.remove("image-comparing");
    }

    onStart(e) {
      const topbar = document.querySelector(".m-topbar");
      const announcement = document.querySelector(".m-announcement-bar");
      let topbarHeight = 0,
        announcementHeight = 0;
      if (topbar) {
        topbarHeight = topbar.offsetHeight;
      }
      if (announcement) {
        announcementHeight = announcement.offsetHeight;
      }
      if (!this.active) return;

      const event = (e.touches && e.touches[0]) || e;
      const x = this.horizontal
        ? event.pageX - this.offsetLeft
        : event.pageY - this.offsetTop - topbarHeight - announcementHeight;

      this.scroll(x);
    }

    scroll(x) {
      const distance = this.horizontal ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;
      this.style.setProperty("--percent", mousePercent + "%");
    }
  }
  customElements.define("m-image-comparison", MImageComparison);
}

if (!customElements.get("m-video-component")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.parentSelector = this.dataset.parent || ".m-video-hero__bg";
      this.parent = this.closest(this.parentSelector);

      switch (this.dataset.type) {
        case "youtube":
          this.initYoutubeVideo();
          break;

        case "vimeo":
          this.initVimeoVideo();
          break;

        case "mp4":
          this.initMp4Video();
          break;
      }
    }

    initYoutubeVideo() {
      this.setAsLoading();
      this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }

    initVimeoVideo() {
      this.setAsLoading();
      this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }

    initMp4Video() {
      const player = this.querySelector("video");

      if (player) {
        const promise = player.play();

        // Edge does not return a promise (video still plays)
        if (typeof promise !== "undefined") {
          promise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              player.setAttribute("controls", "");
            });
        }
      }
    }

    loadScript(videoType) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = videoType === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js";
      });
    }

    setAsLoading() {
      this.parent.setAttribute("loading", true);
    }

    setAsLoaded() {
      this.parent.removeAttribute("loading");
      this.parent.setAttribute("loaded", true);
    }

    setupYoutubePlayer() {
      const videoId = this.dataset.videoId;
      const playerInterval = setInterval(() => {
        if (window.YT) {
          window.YT.ready(() => {
            const element = document.createElement("div");
            this.appendChild(element);

            this.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                showinfo: 0,
                controls: false,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
              },
              events: {
                onReady: this.onYoutubeReady.bind(this),
                onStateChange: this.onYoutubeStateChange.bind(this),
              },
            });
            clearInterval(playerInterval);
          });
        }
      }, 50);
    }

    onYoutubeReady() {
      this.iframe = this.querySelector("iframe"); // iframe once YT loads
      this.iframe.setAttribute("tabindex", "-1");

      if (this.player) this.player.mute();
      if (typeof this.player.playVideo === "function") this.player.playVideo();

      this.setAsLoaded();

      // pause when out of view
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.youtubePlay();
              } else {
                this.youtubePause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      }
    }

    onYoutubeStateChange(event) {
      switch (event.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            // this.closest('.banner').classList.add('video-interactable');
          }
          break;
        case 0: // ended, loop it
          this.youtubePlay();
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    }

    youtubePlay() {
      if (this.player && typeof this.player.playVideo === "function") {
        this.player.playVideo();
      }
    }

    youtubePause() {
      if (this.player && typeof this.player.pauseVideo === "function") {
        this.player.pauseVideo();
      }
    }

    setupVimeoPlayer() {
      const videoId = this.dataset.videoId;

      const playerInterval = setInterval(() => {
        if (window.Vimeo) {
          this.player = new Vimeo.Player(this, {
            id: videoId,
            autoplay: true,
            autopause: false,
            background: false,
            controls: false,
            loop: true,
            height: "100%",
            width: "100%",
          });
          this.player.ready().then(this.onVimeoReady.bind(this));
          clearInterval(playerInterval);
        }
      }, 50);
    }

    onVimeoReady() {
      this.iframe = this.querySelector("iframe");
      this.iframe.setAttribute("tabindex", "-1");

      this.player.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.vimeoPlay();
            } else {
              this.vimeoPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    vimeoPlay() {
      if (this.player && typeof this.player.play === "function") {
        this.player.play();
      }
    }

    vimeoPause() {
      if (this.player && typeof this.player.pause === "function") {
        this.player.pause();
      }
    }
  }
  customElements.define("m-video-component", VideoComponent);
}

if (!customElements.get("m-search-popup")) {
  class MSearchPopup extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-search-container]",
        form: "form",
        input: "[data-search-input]",
        submit: 'button[type="submit"]',
        loading: "[data-spinner]",
        close: "[data-close-search]",
      };

      const searchPopup = document.querySelector("[data-search-popup]");
      if (!searchPopup) return;

      this.domNodes = queryDomNodes(this.selectors, searchPopup);
      this.domNodes.searchPopup = searchPopup;
      document.body.appendChild(searchPopup);
      addEventDelegate({
        selector: "[data-open-search-popup]",
        handler: () => this.openSearchPopup(),
      });

      const { input, submit, close, form } = this.domNodes;
      if (input) {
        input.addEventListener("keydown", (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.closeSearchPopup();
          }
        });
      }
      submit.addEventListener("click", (e) => {
        e.preventDefault();
        if (input.value) {
          form.submit();
        }
      });
      close.addEventListener("click", (e) => {
        this.closeSearchPopup();
      });
      searchPopup.addEventListener("click", (e) => {
        if (e.target === searchPopup) {
          this.closeSearchPopup();
        }
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
        this.closeSearchPopup();
      });
    }

    openSearchPopup() {
      const { searchPopup, input, container } = this.domNodes;
      searchPopup.style.removeProperty("visibility");
      searchPopup.style.setProperty("opacity", "1");
      container.classList.add("m-show-search");
      setTimeout(() => {
        container.classList.remove("duration-300");
        container.style.removeProperty("--m-durations");
        input.focus();
      }, 350);

      MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this);
    }

    closeSearchPopup() {
      const { searchPopup, container } = this.domNodes;
      container.classList.remove("m-show-search");
      searchPopup.style.setProperty("opacity", "0");
      setTimeout(() => {
        searchPopup.style.setProperty("visibility", "hidden");
        container.style.setProperty("--m-durations", ".3s");
      }, 350);
    }
  }

  customElements.define("m-search-popup", MSearchPopup);
}

if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 1,
        navigation: this.showNavigation,
        // loop: true,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}

if (!customElements.get("m-handpicked-products")) {
  class MHandpickedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        products: [".m-product-card"],
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
        slideControls: ".m-slider-controls",
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);
      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

      slideContainer && slideContainer.classList.add("swiper");

      let __this = this;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        loop: false,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstCard = __this.querySelector(".m-product-card");

              if (firstCard && slideControls) {
                const firstImage = firstCard.querySelector(".m-image");
                const prevButton = slideControls.querySelector(".m-slider-controls__button-prev");
                const nextButton = slideControls.querySelector(".m-slider-controls__button-next");
                const cardOffsetTop = window.getComputedStyle(firstCard).getPropertyValue("padding-top");
                const buttonHeight = prevButton.offsetHeight;
                const itemHeight = firstImage.clientHeight;

                slideControls.style.setProperty("--nav-offset-top", parseInt(itemHeight) / 2 + "px");
                slideControls.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(buttonHeight)) / 2 + parseInt(cardOffsetTop) + "px"
                );

                setTimeout(() => {
                  prevButton.classList.remove("m:opacity-0");
                  nextButton.classList.remove("m:opacity-0");
                }, 150);
              }
            }, 100);
          },
        },
      });

      this.swiper = slideContainer && slideContainer.swiper;
    }
  }

  customElements.define("m-handpicked-products", MHandpickedProducts);
}

if (!customElements.get("m-lookbook-slider")) {
  class MLookbookSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        lookbookSlider: ".m-lookbook-slider__inner",
        lookbookIcons: [".m-lookbook-icon"],
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.domNodes.lookbookSlider.dataset.enableSlider === "true";
      this.showPagination = this.domNodes.lookbookSlider.dataset.showPagination === "true";
      this.showNavigation = this.domNodes.lookbookSlider.dataset.showNavigation === "true";
      this.paginationType = this.domNodes.lookbookSlider.dataset.paginationType || "bullets";
      this.items = this.domNodes.lookbookSlider.dataset.items;

      this.slideContainer = this.domNodes.lookbookSlider.querySelector(".swiper");

      if (this.enableSlider) this.initSlider();

      Array.from(this.domNodes.lookbookIcons).forEach((icon) => {
        icon.addEventListener("mouseover", this.onMouseOver.bind(this));
        icon.addEventListener("mouseleave", this.onMouseLeave.bind(this));
      });
    }

    disconnectedCallback() {
      Array.from(this.domNodes.lookbookIcons).forEach((icon) => {
        icon.removeEventListener("mouseover", this.onMouseOver.bind(this));
        icon.removeEventListener("mouseleave", this.onMouseLeave.bind(this));
      });
    }

    initSlider() {
      const controlsContainer = this.domNodes.lookbookSlider.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.slideContainer.querySelector(".swiper-wrapper").childElementCount;

      let swiperOptions = {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 1,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: true,
        pagination: this.showPagination
          ? {
              el: this.domNodes.lookbookSlider.querySelector(".swiper-pagination"),
              clickable: true,
              type: this.paginationType,
            }
          : false,
        breakpoints: {
          1280: {
            slidesPerView: slideItemsLength < this.items ? slideItemsLength : parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          slideChange: (swiper) => {
            const activeIndex = swiper.realIndex;

            Array.from(this.domNodes.lookbookIcons).forEach((icon) => icon.classList.remove("is-active"));
            if (this.domNodes.lookbookIcons[activeIndex])
              this.domNodes.lookbookIcons[activeIndex].classList.add("is-active");
          },
        },
      };

      if (slideItemsLength < this.items) {
        swiperOptions.simulateTouch = false;
        swiperOptions.allowTouchMove = false;
      }

      this.slider = new MinimogLibs.Swiper(this.slideContainer, swiperOptions);

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
    }

    onMouseOver(event) {
      const index = Number(event.target.closest(".m-lookbook-icon").dataset.index);

      if (event.target.dataset.index && this.slider) {
        this.slider.slideToLoop(index);
      }

      const activeItems = this.domNodes.lookbookSlider.querySelectorAll(`[data-swiper-slide-index="${index}"]`);

      Array.from(activeItems).forEach((slide) => slide.querySelector(".m-product-card").classList.add("is-active"));
      this.domNodes.lookbookIcons[index].classList.add("is-active");

      this.classList.add("is-hovering");
    }

    onMouseLeave(event) {
      Array.from(this.slider.slides).forEach((slide) =>
        slide.querySelector(".m-product-card").classList.remove("is-active")
      );
      Array.from(this.domNodes.lookbookIcons).forEach((icon) => icon.classList.remove("is-active"));
      this.classList.remove("is-hovering");
    }
  }

  customElements.define("m-lookbook-slider", MLookbookSlider);
}

if (!customElements.get("favorite-product-slider")) {
  class FavoriteProductSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        mainImages: ".m-favorite-product-slider__images",
        thumbs: ".m-favorite-product-slider__thumbs",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
      this.mediaSize = parseInt(this.dataset.mediaSize);

      this.mainImagesContainer = this.domNodes.mainImages.querySelector(".swiper");
      this.thumbsContainer = this.domNodes.thumbs.querySelector(".swiper");
      this.spacingDesktop = this.dataset.spacingDesktop || 30;
      this.spacingMobile = this.dataset.spacingMobile || 15;
      this.initSlider();
    }

    initSlider() {
      this.initMainImagesSlider();
      this.initThumbsSlider();

      this.thumbsSlider.on("slideChange", (swiper) => {
        const { realIndex } = swiper;
        let index = realIndex - 1;
        if (index < 0) {
          index = this.mediaSize - 1;
        }
        this.mainImagesSlider.slideToLoop(index);
      });

      this.mainImagesSlider.on("slideChange", (swiper) => {
        const { slides, realIndex } = swiper;
        let index = realIndex + 1;
        if (index > this.mediaSize) {
          index = 0;
        }
        this.playActiveMedia(slides[index]);
      });
    }

    initMainImagesSlider() {
      const controlsContainer = this.domNodes.mainImages.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");

      this.mainImagesSlider = new MinimogLibs.Swiper(this.mainImagesContainer, {
        modules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination, MinimogLibs.Swiper.Thumbs],
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: this.domNodes.mainImages.querySelector(".swiper-pagination"),
          clickable: true,
          type: "fraction",
        },
        autoplay: false,
        threshold: 2,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        breakpoints: {
          768: {
            simulateTouch: false,
            allowTouchMove: false,
            showPagination: false,
            showNavigation: false,
          },
        },
        simulateTouch: true,
        allowTouchMove: true,
      });
    }

    initThumbsSlider() {
      const thumbsControlsContainer = this.domNodes.thumbs.querySelector(".m-slider-controls");
      const thumbsPrevButton =
        thumbsControlsContainer && thumbsControlsContainer.querySelector(".m-slider-controls__button-prev");
      const thumbsNextButton =
        thumbsControlsContainer && thumbsControlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.domNodes.thumbs.querySelector(".swiper-wrapper").childElementCount;

      this.thumbsSlider = new MinimogLibs.Swiper(this.thumbsContainer, {
        modules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination, MinimogLibs.Swiper.Thumbs],
        initialSlide: slideItemsLength > 1 ? 1 : 0,
        slidesPerView: slideItemsLength == 2 ? 1 : 2,
        loop: true,
        navigation: {
          nextEl: thumbsNextButton,
          prevEl: thumbsPrevButton,
        },
        autoplay: false,
        pagination: {
          el: this.domNodes.thumbs.querySelector(".swiper-pagination"),
          clickable: true,
          type: "fraction",
        },
        spaceBetween: parseInt(this.spacingMobile),
        breakpoints: {
          1024: {
            spaceBetween: parseInt(this.spacingDesktop),
          },
        },
        threshold: 2,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
    }

    playActiveMedia(selected) {
      const deferredMedia = selected.querySelector(".deferred-media");
      if (deferredMedia) {
        const autoplay = deferredMedia.dataset.autoPlay === "true";
        if (autoplay) {
          deferredMedia.loadContent(false);
        }
      }
    }
  }
  customElements.define("favorite-product-slider", FavoriteProductSlider);
}

if (!customElements.get("m-select-component")) {
  class MSelectComponent extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        elSelectNative: ".js-selectNative",
        elSelectCustom: ".js-selectCustom",
        elSelectCustomBox: ".m-select-custom--trigger",
        elSelectCustomOpts: ".m-select-custom--options",
        elSelectCustomTriggerText: ".m-select-custom--trigger-text",
        customOptionList: [".m-select-custom--option"],
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.optionChecked = "";
      this.reversedCssClass = "m-select-custom--reversed";

      window.addEventListener("DOMContentLoaded", () => {
        this.classList.remove("m:hidden");
      });
      this.setDefaultValue();
      this.initSelect();
    }

    setDefaultValue() {
      const { elSelectNative } = this.domNodes;
      const value = elSelectNative.options[elSelectNative.selectedIndex].value;
      const text = elSelectNative.options[elSelectNative.selectedIndex].text;
      this.updateCustomSelectChecked(value, text);
    }

    initSelect() {
      this.classList.remove("m:hidden");
      const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;

      elSelectCustomBox.addEventListener("click", () => {
        const isClose = !elSelectCustom.classList.contains("isActive");
        if (isClose) {
          this.openSelect();
        } else {
          this.closeSelect();
        }
      });

      this.domNodes.customOptionList.forEach((option) => {
        option.addEventListener("click", (e) => {
          const value = e.target.getAttribute("data-value");

          this.closeSelect();
          if (value != elSelectNative.value) {
            // Do nothing if click selected option.
            elSelectNative.value = value;
            this.closeSelect();
            this.updateCustomSelectChecked(value, e.target.textContent);
            elSelectNative.dispatchEvent(new Event("change"));
          }
          elSelectNative.dispatchEvent(new Event("click"));
        });
      });
    }

    openSelect() {
      const allCustomSelect = document.querySelectorAll("m-select-component");
      document.addEventListener("click", (e) => this.handleClickOutside(e));
      if (allCustomSelect.length > 0) {
        allCustomSelect.forEach((select) => {
          select.closeSelect();
        });
      }

      this.domNodes.elSelectCustom.classList.remove(this.reversedCssClass);

      /**
       * Reverse position of dropdown list if it has no space to show.
       */
      if (
        (!MinimogTheme.config.isRTL &&
          document.documentElement.clientWidth < this.offsetLeft + this.domNodes.elSelectCustomOpts.offsetWidth + 10) ||
        (MinimogTheme.config.isRTL &&
          this.offsetLeft + this.offsetWidth <= this.domNodes.elSelectCustomOpts.offsetWidth + 10)
      ) {
        this.domNodes.elSelectCustom.classList.add(this.reversedCssClass);
      }

      this.domNodes.elSelectCustom.classList.add("isActive");
    }

    closeSelect() {
      this.domNodes.elSelectCustom.classList.remove("isActive");
    }

    updateCustomSelectChecked(value, text) {
      const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
      const prevValue = this.optionChecked;
      const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${prevValue}"`);

      const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

      if (elPrevOption) {
        elPrevOption.classList.remove("isActive");
      }

      if (elOption) {
        elOption.classList.add("isActive");
      }

      elSelectCustomTriggerText.textContent = text;
      this.optionChecked = value;
    }

    handleClickOutside(e) {
      const { elSelectCustom } = this.domNodes;
      const didClickedOutside = !elSelectCustom.contains(e.target);
      if (didClickedOutside) {
        this.closeSelect();
      }
    }
  }

  customElements.define("m-select-component", MSelectComponent);
}

if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);
      this.acc = new MinimogLibs.Accordion(this, { presetContentHeight: true, onload: true });

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          if (this.acc) {
            const accItem = this.acc.domNodes.items[index];
            const isAccOpen = accItem && accItem.classList.contains("open");
            if (!isAccOpen) {
              this.acc && this.acc.toggle(index);
            }
          }
          this.tabs && this.tabs.setActiveTab(index);
        });
        document.addEventListener("shopify:block:deselect", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          if (this.acc) {
            const accItem = this.acc.domNodes.items[index];
            const isAccOpen = accItem && accItem.classList.contains("open");
            if (isAccOpen) {
              this.acc && this.acc.toggle(index);
            }
          }
        });
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}

if (!customElements.get("m-instagram")) {
  class MInstagram extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const { MinimogThemeScripts } = window;
      const { accessToken, imagesCount } = this.dataset;
      if (accessToken) {
        loadAssets([MinimogThemeScripts.instagram], "instagram-module", () => {
          new MinimogTheme.Instagram(this, accessToken, imagesCount);
        });
      }
    }
  }

  customElements.define("m-instagram", MInstagram);
}

if (!customElements.get("m-aside-instagram")) {
  class MAsideInstagram extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const container = this.querySelector(".m-aside-instagram");
      if (container) {
        const { accessToken, imagesCount } = container.dataset;
        if (accessToken) {
          const { MinimogThemeScripts } = window;
          loadAssets([MinimogThemeScripts.instagram], "instagram-module-blog", () => {
            new MinimogTheme.Instagram(container, accessToken, imagesCount);
          });
        } else {
          console.warn("Failed to init Instagram section! Missing Access Token");
        }
      }
    }
  }

  customElements.define("m-aside-instagram", MAsideInstagram);
}
class MQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.quantityUpdateUnsubscriber = undefined;
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.closest("button").name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".m-quantity__button[name='minus']");
      buttonMinus.classList.toggle("m:disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".m-quantity__button[name='plus']");
      buttonPlus.classList.toggle("m:disabled", value >= max);
    }
  }
}

customElements.define("m-quantity-input", MQuantityInput);

class MTabsComponent extends HTMLElement {
  constructor() {
    super();
    this.KEYCODE = {
      DOWN: 40,
      LEFT: 37,
      RIGHT: 39,
      UP: 38,
      HOME: 36,
      END: 35,
    };
  }

  connectedCallback() {
    this.addEventListener("click", this.onclick);
    this.addEventListener("keydown", this.onKeydown);
    if (!this.hasAttribute("role")) this.setAttribute("role", "tablist");
    Promise.all([customElements.whenDefined("m-tab-header"), customElements.whenDefined("m-tab-content")]).then(() => {
      this.linkPanels();
    });
  }

  linkPanels() {
    const tabs = this.allTabs();
    tabs.forEach((tab) => {
      const panel = this.querySelector(`#panel-${tab.id}`);
      tab.setAttribute("aria-controls", panel.id);
      panel.setAttribute("aria-labelledby", tab.id);
    });
    const selectedTab = tabs.find((tab) => tab.selected) || tabs[0];
    this.selectTab(selectedTab);
  }

  allTabs() {
    return Array.from(this.querySelectorAll("m-tab-header"));
  }

  allPanels() {
    return Array.from(this.querySelectorAll("m-tab-content"));
  }

  reset() {
    const tabs = this.allTabs();
    const panels = this.allPanels();
    tabs.forEach((tab) => (tab.selected = false));
    panels.forEach((panel) => (panel.hidden = true));
  }

  panelForTab(tab) {
    const panelId = tab.getAttribute("aria-controls");
    return this.querySelector(`#${panelId}`);
  }

  prevTab() {
    const tabs = this.allTabs();
    let newIdx = tabs.findIndex((tab) => tab.selected) - 1;
    return tabs[(newIdx + tabs.length) % tabs.length];
  }

  firstTab() {
    const tabs = this.allTabs();
    return tabs[0];
  }

  lastTab() {
    const tabs = this.allTabs();
    return tabs[tabs.length - 1];
  }

  nextTab() {
    const tabs = this.allTabs();
    let newIdx = tabs.findIndex((tab) => tab.selected) + 1;
    return tabs[newIdx % tabs.length];
  }

  selectTab(newTab) {
    this.reset();
    const newPanel = this.panelForTab(newTab);
    if (!newPanel) throw new Error(`No panel with id ${newPanelId}`);
    newTab.selected = true;
    newPanel.hidden = false;
    // newTab.focus();
  }

  onclick(event) {
    if (event.target.getAttribute("role") !== "tab") return;
    this.selectTab(event.target);
  }

  onKeydown(event) {
    if (event.target.getAttribute("role") !== "tab") return;
    if (event.altKey) return;
    let newTab;
    switch (event.keyCode) {
      case this.KEYCODE.LEFT:
      case this.KEYCODE.UP:
        newTab = this.prevTab();
        break;

      case this.KEYCODE.RIGHT:
      case this.KEYCODE.DOWN:
        newTab = this.nextTab();
        break;

      case this.KEYCODE.HOME:
        newTab = this.firstTab();
        break;

      case this.KEYCODE.END:
        newTab = this.lastTab();
        break;

      default:
        return;
    }
    event.preventDefault();
    this.selectTab(newTab);
  }
}

customElements.define("m-tabs-component", MTabsComponent);

class MTabHeader extends HTMLElement {
  static get observedAttributes() {
    return ["selected"];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this.setAttribute("role", "tab");
    this.setAttribute("aria-selected", "false");
    this.setAttribute("tabindex", -1);
    this.upgradeProperty("selected");
  }

  upgradeProperty(prop) {
    if (this.hasOwnProperty(prop)) {
      let value = this[prop];
      delete this[prop];
      this[prop] = value;
    }
  }

  attributeChangedCallback() {
    const value = this.hasAttribute("selected");
    this.setAttribute("aria-selected", value);
    this.setAttribute("tabindex", value ? 0 : -1);
  }

  set selected(value) {
    value = Boolean(value);
    if (value) this.setAttribute("selected", "");
    else this.removeAttribute("selected");
  }

  get selected() {
    return this.hasAttribute("selected");
  }
}

customElements.define("m-tab-header", MTabHeader);

class MTabContent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setAttribute("role", "tabpanel");
  }
}

customElements.define("m-tab-content", MTabContent);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("[data-main-details-toggle]");
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("[data-summary-button]").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(".m-menu-drawer__close-button").forEach((button) => {
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("[data-main-details-toggle][open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("[data-summary-button]"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    event.preventDefault();
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.closest("[data-main-details-toggle]");
    const parentMenuElement = detailsElement.closest(".m-has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 1280px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        detailsElement.setAttribute("open", "");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("[data-main-details-toggle]").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove("m:overflow-hidden");
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    elementToFocus.setAttribute("aria-expanded", false);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("[data-main-details-toggle]");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    const dropdownMenu = this.querySelector("header-dropdown-menu");
    dropdownMenu && dropdownMenu.closeAll();
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("[data-summary-button]").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("[data-summary-button]"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("[data-main-details-toggle][open]")) {
          trapFocus(
            detailsElement.closest("[data-main-details-toggle][open]"),
            detailsElement.querySelector("[data-summary-button]")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    document.addEventListener("unmatchMobile", () => document.body.classList.remove("m:overflow-hidden"));
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".m-section-header");
    this.mobileStickybar = document.querySelector(".m-mobile-sticky-bar");
    this.stickyAddTocart = document.querySelector(".m-sticky-addtocart");
    this.borderOffset =
      this.borderOffset || this.closest(".m-header").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      if (this.mobileStickybar) this.mobileStickybar.style.transform = "translateY(100%)";
      if (this.stickyAddTocart) this.stickyAddTocart.style.transform = "translateY(100%)";
      this.mainDetailsToggle.classList.add("menu-opening");
      this.mainDetailsToggle.setAttribute("open", "");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("m:overflow-hidden");
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    const dropdownMenu = this.querySelector("header-dropdown-menu");
    dropdownMenu && dropdownMenu.closeAll();
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    if (this.mobileStickybar) this.mobileStickybar.style.transform = "translate(0)";
    if (this.stickyAddTocart) this.stickyAddTocart.style.removeProperty("transform");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class HeaderDropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.submenus = this.querySelectorAll(".m-menu-dropdown__submenu");
    this.querySelectorAll("[data-toggle-dropdown]").forEach((toggle) => {
      toggle.addEventListener("click", this.onToggle.bind(this));
    });
  }

  onToggle(event) {
    event.preventDefault();
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.closest("[data-main-toggle-dropdown]");
    const contentElement = detailsElement.querySelector(".m-menu-dropdown__submenu");
    const isOpen = detailsElement.hasAttribute("open");

    if (isOpen) {
      detailsElement.removeAttribute("open");
      detailsElement.classList.remove("menu-dropdown-open");
      contentElement.style.height = contentElement.scrollHeight + "px";
      setTimeout(() => {
        contentElement.style.height = "0px";
      });
    } else {
      detailsElement.setAttribute("open", "");
      detailsElement.classList.add("menu-dropdown-open");
      contentElement.style.height = contentElement.scrollHeight + "px";
      setTimeout(() => {
        contentElement.style.height = "auto";
      }, 300);
    }
  }

  closeAll() {
    const allDropdown = this.querySelectorAll("[data-main-toggle-dropdown]");
    allDropdown &&
      allDropdown.forEach((dropdown) => {
        const contentElement = dropdown.querySelector(".m-menu-dropdown__submenu");
        dropdown.removeAttribute("open");
        dropdown.classList.remove("menu-dropdown-open");
        contentElement.style.height = "0px";
      });
  }
}

customElements.define("header-dropdown-menu", HeaderDropdownMenu);

class Megamenu extends HTMLElement {
  constructor() {
    super();

    this.template = this.dataset.template;
    this.openDefault = this.dataset.openDefault === "true" || false;
    this.toggle = this.querySelector("[data-menu-toggle]");
    this.content = this.querySelector("[data-menu-content]");
    this.header = document.querySelector(".m-section-header");
    this.init();
  }

  init() {
    if (!this.openDefault || this.header.classList.contains("scrolled-past-header")) {
      this.addEventListener("mouseenter", this.open.bind(this));
      this.addEventListener("mouseleave", this.close.bind(this));
    }
  }

  close() {
    if (!this.header.classList.contains("scrolled-past-header") && this.openDefault) return;
    this.classList.remove("menu-open");
    this.closeAnimation(this);
  }

  open() {
    setTimeout(() => {
      this.setAttribute("open", "");
      this.classList.add("menu-open");
    });
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - this.toggle.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 100) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("mega-menu", Megamenu);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector(".m-modal__container");
    this.mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");
    this.headerDrawer = document.querySelector("header-drawer");
    this.summaryToggle = this.querySelector(".m-modal__toggle");

    this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener("click", this.close.bind(this));
    });

    this.summaryToggle.setAttribute("role", "button");

    document.addEventListener("unmatchMobile", () => document.body.classList.remove("m:overflow-hidden"));

    this.searchModal = this.querySelector(".m-search-modal");
    if (this.searchModal) {
      this.style.setProperty("--search-modal-height", `${this.searchModal.offsetHeight}px`);
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest(".m-modal__container").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("m-modal-overlay")) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const modalContainer = event.target.closest(".m-modal__container");
    modalContainer.classList.add("m-modal-open");
    modalContainer.setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("m:overflow-hidden");
    if (this.mobileStickyBar) this.mobileStickyBar.style.transform = "translateY(100%)";

    setTimeout(() => {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }, 250);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.classList.remove("m-modal-open");
    setTimeout(() => {
      this.detailsContainer.removeAttribute("open");
    }, 250);
    document.body.removeEventListener("click", this.onBodyClickEvent);
    if (this.mobileStickyBar && !this.headerDrawer.mainDetailsToggle.classList.contains("menu-opening"))
      this.mobileStickyBar.style.transform = "translate(0)";
    document.body.classList.remove("m:overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // Save product Id
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "minimog:recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // Check current product already exists, if not push to array
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // Save to localStorage
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 10)));
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slideControls: ".m-slider-controls",
      slideContainer: ".m-mixed-layout__wrapper",
    };
    this.productToshow = parseInt(this.dataset.productToShow);
    this.enableSlider = this.dataset.enableSlider === "true";
    this.showPagination = this.dataset.showPagination === "true";
    this.showNavigation = this.dataset.showNavigation === "true";
    this.paginationType = this.dataset.paginationType || "bullets";
    this.mobileLayout = this.dataset.mobileLayout;
    this.items = this.dataset.items;
    this.laptopItems = this.dataset.laptopItems;
    this.tabletItems = this.dataset.tabletItems;
    this.mobileItems = this.dataset.mobileItems || 2;

    this.container = this.closest(".m-section");

    MinimogTheme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("recently-viewed-products");
        this.products = recommendations.querySelectorAll(".m-product-card").length;
        if (this.products <= 0) {
          this.container && this.container.classList.add("m:hidden");
        }
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initByScreenSize();
          document.addEventListener("matchMobile", () => {
            this.initByScreenSize();
          });
          document.addEventListener("unmatchMobile", () => {
            this.initByScreenSize();
          });

          MinimogTheme.CompareProduct.setCompareButtonsState();
          MinimogTheme.Wishlist.setWishlistButtonsState();

          // Init tooltip
          reInitTooltip(this);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initByScreenSize() {
    const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

    if (this.enableSlider) {
      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    if (!this.enableSlider || this.products <= parseInt(this.items)) {
      slideControls && slideControls.classList.add("m:hidden");
    }
  }

  initSlider() {
    const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);
    const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
    const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");

    slideContainer && slideContainer.classList.add("swiper");

    let __this = this;

    this.slider = new MinimogLibs.Swiper(slideContainer, {
      modules: MinimogTheme.config.swiperModules,
      slidesPerView: parseInt(this.mobileItems),
      slidesPerGroup: 1,
      threshold: 2,
      loop: this.products <= parseInt(this.items) ? false : true,
      navigation: this.showNavigation
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      pagination: this.showPagination
        ? {
            el: this.querySelector(".swiper-pagination"),
            type: this.paginationType,
            clickable: true,
          }
        : false,
      breakpoints: {
        768: {
          slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
        },
        1024: {
          slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
        },
        1280: {
          slidesPerView: parseInt(this.items),
        },
      },
      threshold: 2,
      on: {
        init: function () {
          setTimeout(() => {
            // Calculate controls position
            const firstCard = __this.querySelector(".m-product-card");

            if (firstCard && slideControls) {
              const firstImage = firstCard.querySelector(".m-image");
              const prevButton = slideControls.querySelector(".m-slider-controls__button-prev");
              const nextButton = slideControls.querySelector(".m-slider-controls__button-next");
              const cardOffsetTop = window.getComputedStyle(firstCard).getPropertyValue("padding-top");
              const buttonHeight = prevButton.offsetHeight;
              const itemHeight = firstImage.clientHeight;

              slideControls.style.setProperty("--nav-offset-top", parseInt(itemHeight) / 2 + "px");
              slideControls.style.setProperty(
                "--nav-transform",
                (-1 * parseInt(buttonHeight)) / 2 + parseInt(cardOffsetTop) + "px"
              );

              setTimeout(() => {
                prevButton.classList.remove("m:opacity-0");
                nextButton.classList.remove("m:opacity-0");
              }, 150);
            }
          }, 100);
        },
      },
    });

    this.swiper = slideContainer && slideContainer.swiper;
  }

  getQueryString() {
    const cookieName = "minimog:recently-viewed";
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items
      .map((item) => "id:" + item)
      .slice(0, this.productToshow)
      .join(" OR ");
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);

if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.buttonWrapper = this.querySelector(".m-product-tabs__buttons");
      this.buttons = this.querySelectorAll(".m-product-tabs__button");
      this.contentWrapper = this.querySelector(".m-product-tabs__contents");
      this.templates = this.querySelector("template").content.cloneNode(true);

      this.productToshow = parseInt(this.dataset.productToShow);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.currentActiveIndex = -1;
      this.currentTab = null;

      this.sectionId = this.dataset.sectionId;

      this.buttons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });

      this.setActiveTab(0);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          if (event.detail.sectionId != this.sectionId) return;
          const tabHeader = event && event.target;
          const index = tabHeader && Number(tabHeader.dataset.tabIndex);
          this.setActiveTab(index);
        });
      }
    }

    onButtonClick(event) {
      const currentTarget = event.currentTarget;
      const tabIndex = currentTarget.dataset.tabIndex;
      if (currentTarget.hasAttribute("data-active")) return;
      this.setActiveTab(tabIndex);
    }

    setActiveTab(tabIndex) {
      this.contents = this.querySelectorAll(".m-product-tabs__content");

      let currHeader, newHeader, newTab;

      currHeader = this.buttons && this.buttons[this.currentActiveIndex];
      newHeader = this.buttons && this.buttons[tabIndex];

      this.tabContentActive = this.templates.querySelector(`[data-tab-index="${tabIndex}"]`);
      this.tabButtonActive = this.buttonWrapper.querySelector(`[data-tab-index="${tabIndex}"]`);

      this.tabContentActive && this.contentWrapper.appendChild(this.tabContentActive);
      this.tabContentActive = this.tabContentActive
        ? this.tabContentActive
        : this.contentWrapper.querySelector(`[data-tab-index="${tabIndex}"]`);

      newTab = this.tabContentActive;

      currHeader && currHeader.classList.remove("m-tab-active");
      this.currentTab && this.currentTab.classList.remove("m-tab-active");
      currHeader && currHeader.removeAttribute("data-active");

      newHeader && newHeader.classList.add("m-tab-active");
      newHeader && newHeader.setAttribute("data-active", true);
      newTab && newTab.classList.add("m-tab-active");

      this.enableSlider = this.tabContentActive && this.tabContentActive.dataset.enableSlider === "true";
      this.slideControls = this.tabContentActive && this.tabContentActive.querySelector(".m-slider-controls");
      this.slideContainer = this.tabContentActive && this.tabContentActive.querySelector(".m-mixed-layout__wrapper");

      MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
      MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();

      this.initByScreenSize(this.enableSlider, this.slideContainer, this.slideControls);
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize(this.enableSlider, this.slideContainer, this.slideControls);
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize(this.enableSlider, this.slideContainer, this.slideControls);
      });

      // Init tooltip
      reInitTooltip(newTab);

      this.currentActiveIndex = tabIndex;
      this.currentTab = newTab;
    }

    initByScreenSize(enableSlide, container, controls) {
      if (!enableSlide) return;

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        controls && controls.classList.add("m:hidden");
        container && container.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        controls && controls.classList.remove("m:hidden");
        this.initSlider(container, controls);
      }
    }

    initSlider(container, controls) {
      const prevButton = controls && controls.querySelector(".m-slider-controls__button-prev");
      const nextButton = controls && controls.querySelector(".m-slider-controls__button-next");
      const pagination = controls && controls.querySelector(".swiper-pagination");

      container && container.classList.add("swiper");

      this.slider = new MinimogLibs.Swiper(container, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        threshold: 2,
        loop: true,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: pagination,
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));

              const firstCard = container.querySelector(".m-product-card");

              if (firstCard && controls) {
                const firstImage = firstCard.querySelector(".m-image") || firstCard.querySelector(".m-placeholder-svg");
                const prevButton = controls.querySelector(".m-slider-controls__button-prev");
                const nextButton = controls.querySelector(".m-slider-controls__button-next");
                const cardOffsetTop = window.getComputedStyle(firstCard).getPropertyValue("padding-top");
                const buttonHeight = prevButton.offsetHeight;
                const itemHeight = firstImage.clientHeight;

                controls.style.setProperty("--nav-offset-top", parseInt(itemHeight) / 2 + "px");
                controls.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(buttonHeight)) / 2 + parseInt(cardOffsetTop) + "px"
                );

                setTimeout(() => {
                  prevButton.classList.remove("m:opacity-0");
                  nextButton.classList.remove("m:opacity-0");
                }, 150);
              }
            }, 150);
          },
        },
      });

      this.swiper = container && container.swiper;
    }
  }

  customElements.define("product-tabs", ProductTabs);
}

if (!customElements.get("m-collection-spotlight")) {
  class CollectionSpotlight extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        products: [".m-product-card"],
        featuredProductMediaMain: ".m-product-featured__media-main",
        featuredProductMediaMainWrapper: ".m-product-featured__media-main-wrapper",
        featuredProductMediaThumb: ".m-product-featured__media-thumb",
        featuredProductMediaThumbWrapper: ".m-product-featured__media-thumb-wrapper",
        slideContainer: ".m-mixed-layout__wrapper",
        slideContainerWrapper: ".m-collection-spotlight__product-list",
        slideControls: ".m-collection-spotlight__product-list .m-slider-controls",
      };

      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.initFeaturedProduct();

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideContainerWrapper } = queryDomNodes(this.selectors, this);
      const prevButton =
        slideContainerWrapper && slideContainerWrapper.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        slideContainerWrapper && slideContainerWrapper.querySelector(".m-slider-controls__button-next");

      slideContainer && slideContainer.classList.add("swiper");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination, MinimogLibs.Swiper.Grid],
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        threshold: 2,
        grid: {
          rows: 1,
          fill: "column",
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: slideContainerWrapper.querySelector(".swiper-pagination"),
          type: "fraction",
          clickable: true,
        },
        breakpoints: {
          1280: {
            slidesPerView: 1,
            pagination: {
              type: "bullets",
            },
            grid: {
              rows: 2,
              fill: "row",
            },
          },
        },
      });

      this.swiper = slideContainer && slideContainer.swiper;
    }

    initFeaturedProduct() {
      const slideModules = [...MinimogTheme.config.swiperModules, MinimogLibs.Swiper.Thumbs];
      const {
        featuredProductMediaMain,
        featuredProductMediaThumb,
        featuredProductMediaMainWrapper,
        featuredProductMediaThumbWrapper,
      } = queryDomNodes(this.selectors, this);

      const prevButton =
        featuredProductMediaMainWrapper &&
        featuredProductMediaMainWrapper.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        featuredProductMediaMainWrapper &&
        featuredProductMediaMainWrapper.querySelector(".m-slider-controls__button-next");
      const prevButtonThumb =
        featuredProductMediaThumbWrapper &&
        featuredProductMediaThumbWrapper.querySelector(".m-slider-controls__button-prev");
      const nextButtonThumb =
        featuredProductMediaThumbWrapper &&
        featuredProductMediaThumbWrapper.querySelector(".m-slider-controls__button-next");

      featuredProductMediaMain && featuredProductMediaMain.classList.add("swiper");

      const featuredSliderThumb = new MinimogLibs.Swiper(featuredProductMediaThumb, {
        modules: slideModules,
        direction: "vertical",
        spaceBetween: 10,
        slidesPerView: 5,
        watchOverflow: true,
        navigation: {
          nextEl: nextButtonThumb,
          prevEl: prevButtonThumb,
        },
        breakpoints: {
          1024: {
            slidesPerView: 7,
          },
          1280: {
            slidesPerView: 5,
          },
        },
      });

      const featuredSlider = new MinimogLibs.Swiper(featuredProductMediaMain, {
        modules: slideModules,
        thumbs: { swiper: featuredSliderThumb },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: featuredProductMediaMainWrapper.querySelector(".swiper-pagination"),
          type: "fraction",
          clickable: true,
        },
      });

      let draggable = true,
        mediaType = "",
        visibleSlides = [];

      featuredSlider.on("slideChange", (swiper) => {
        window.pauseAllMedia(this);
        try {
          const { slides, activeIndex } = swiper;

          visibleSlides = [activeIndex];

          for (let index of visibleSlides) {
            const currSlide = slides[index];
            if (currSlide) {
              mediaType = currSlide.dataset.mediaType;
            }
            if (mediaType === "model") break;
          }

          // Change touchMove state, for making the model inside slide draggable
          if (mediaType === "model") {
            featuredSlider.allowTouchMove = false;
            draggable = false;
          } else {
            if (!draggable) featuredSlider.allowTouchMove = true;
            draggable = true;
          }
        } catch (error) {
          console.error("Failed to execute slideChange event.", error);
        }
      });
    }
  }

  customElements.define("m-collection-spotlight", CollectionSpotlight);
}

if (!customElements.get("m-form-subscribe")) {
  class FormSubscribe extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.agreeTerms = this.querySelector("[name='agree_terms']");
      this.errorWrapper = this.querySelector(".m-product-form-message");
      this.buttonSubmit = this.querySelector(".m-newsletter-form__button");
      this.input = this.querySelector(".m-newsletter-form__input");

      this.buttonSubmit.addEventListener("click", this.hanldeSubmit.bind(this));
    }

    hanldeSubmit(e) {
      e.preventDefault();
      let isValid = true;
      if (this.input.value == "") {
        isValid = false;
        return window.MinimogTheme.Notification.show({
          target: this.errorWrapper,
          method: "appendChild",
          type: "warning",
          message: "Email cannot be blank",
        });
      }
      if (!this.validateEmail(this.input.value)) {
        isValid = false;
        return window.MinimogTheme.Notification.show({
          target: this.errorWrapper,
          method: "appendChild",
          type: "warning",
          message: "Please enter the correct email syntax",
        });
      }
      if (this.agreeTerms && !this.agreeTerms.checked) {
        isValid = false;
        return window.MinimogTheme.Notification.show({
          target: this.errorWrapper,
          method: "appendChild",
          type: "warning",
          message: "Please agree to the Terms and Conditions",
        });
      }

      if (isValid) this.form.submit();
    }

    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
  }

  customElements.define("m-form-subscribe", FormSubscribe);
}
